import { Grid } from 'ldrs/react'
import 'ldrs/react/Grid.css'
const ClerkLoaderComp = () => {
return (<>
<Grid
  size="60"
  speed="1.5"
  color="black" 
/>
</>)
}

export default ClerkLoaderComp